import { render, staticRenderFns } from "./DocumentEditForm.vue?vue&type=template&id=28168b4a&scoped=true&"
import script from "./DocumentEditForm.vue?vue&type=script&lang=js&"
export * from "./DocumentEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEditForm.vue?vue&type=style&index=0&id=28168b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28168b4a",
  null
  
)

export default component.exports